import { DashboardStats } from "../../components/admin/DashboardStats";
import { PendingUsers } from "../../components/admin/PendingUsers";
import { RecentMessages } from "../../components/admin/RecentMessages";

const AdminDashboard = () => {
  return (
    <div className="container py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Admin Dashboard</h1>
        <p className="text-muted-foreground">
          Monitor system activity and manage pending users
        </p>
      </div>

      {/* Stats Overview */}
      <DashboardStats />

      <div className="grid gap-6 md:grid-cols-2">
        {/* Pending Users */}
        <PendingUsers />

        {/* Recent Messages */}
        <RecentMessages />
      </div>
    </div>
  );
};

export default AdminDashboard;
